module.exports = __webpack_public_path__ + "static/media/womens_fashion.c494e61f.jpg";